import { render, staticRenderFns } from "./MarketingOverviewSport.vue?vue&type=template&id=72bdc39e"
import script from "./MarketingOverviewSport.vue?vue&type=script&lang=js"
export * from "./MarketingOverviewSport.vue?vue&type=script&lang=js"
import style0 from "./MarketingOverviewSport.vue?vue&type=style&index=0&id=72bdc39e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports